import React from 'react';
import { Link } from 'react-router-dom';
import { RoomSlideImage } from './RoomSlideImage';
import PropTypes from 'prop-types';

const RoomCardElement = ({ room }) => {

  return (<>
    <div className='card-room mt-8'>
      <div className='flex flex-start'>
        <img src="/assets/img/icons/room2-icon.svg" alt="Mini icono" width="32px" height="32px" />
        <span className='title ml-2'>{room.name}</span>
      </div>

      <div className='mt-4'>
        <RoomSlideImage images={room.hotelRoomGalleries || []} />
      </div>

      <div>
        <ul className='list-disc' dangerouslySetInnerHTML={{ __html: room.hotelRoomLabels[0].roomTypeDescription }}>
          {/* <li>Incluye WI-FI</li>
          <li>10 por ciento cupón para comidas y bebidas</li>
          <li>Consulte los detalles de la tarifa</li> */}
        </ul>
      </div>
      <div className='text-right'>
        <Link to={"detail/" + room.id} style={{ color: '#67BAAF' }}>Ver detalle</Link>
      </div>
    </div>
  </>);
};


RoomCardElement.propTypes = {
  room: PropTypes.object
}

export default React.memo(RoomCardElement);